import React, { useState } from 'react';

import { useHiddenFileSelect } from '@paragon/client-tools';
import { sealingService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { useAppDispatch } from '../hooks';

interface Props {
  readonly jobId: number;
  readonly reviewUrl: string;
}

export function AddMiscellaneousFilesDialog(props: Props) {
  const { jobId, reviewUrl } = props;
  const dispatch = useAppDispatch();

  const [isUploading, setIsUploading] = useState(false);

  const [renderHiddenSelect, selectFile] = useHiddenFileSelect('*', true);

  async function onSelectFileClick() {
    const chosenFiles = await selectFile();

    setIsUploading(true);

    try {
      await sealingService.jobs.addMiscellaneousFiles(
        jobId,
        chosenFiles.map((file) => ({
          name: `${file.filename}.${file.filetype}`,
          index: undefined,
          url: file.contents,
        })),
      );
      window.open(reviewUrl, '_blank');
    } catch (err) {
      console.error(err);
      dispatch(enqueueError('Error processing miscellaneous files. Please contact Paragon Customer Support.'));
    } finally {
      setIsUploading(false);
      dispatch(closeCurrentPopup());
    }
  }

  return (
    <div>
      {renderHiddenSelect()}

      <Dialog
        title="Upload Miscellaneous Files?"
        onCancel="close"
        submitText="Upload"
        cancelText="Skip"
        onSubmit={onSelectFileClick}
        onClose={() => {
          window.open(reviewUrl, '_blank');
          dispatch(closeCurrentPopup());
        }}
        disabled={isUploading}
      >
        <p>
          Miscellaneous files give repair engineers additional information. If you have photos of the repairs or files
          from other software, those can be added here. A written description of the repairs may also be added on the
          next page.
        </p>
      </Dialog>
    </div>
  );
}
